import React from "react";
import {checkPermission} from "../../utils/common";
import Dashboard from "./dashboard";
import Profile from "./profile";
import {
        Routes,
        Route
} from "react-router-dom";
import CreateSchool from "./system/school-info/create";
import DetailSchool from "./system/school-info/detail";
import EditSchool from "./system/school-info/edit";
import DataTransferManagement from "./system/data-transfer";
import DataDeclarationManagement from "./system/data-declaration";
import GroupUserManagement from "./system/group-user";
import UserManagement from "./system/user";
import DetailUser from "./system/user/detail";
import StudentInfoManagement from "./student/info";
import CreateStudentManagement from "./student/info/create";
import DetailStudentManagement from "./student/info/detail";
import EditStudentManagement from "./student/info/edit";
import AcceptingTransferStudentManagement from "./student/accepting/transfer-school";
import StaffManagement from "./staff/info";
import CreateStaff from "./staff/info/create";
import EditStaff from "./staff/info/edit";
import DetailStaff from "./staff/info/detail";
import AdmissionsManagement from "./admissions/info";
import ClientsManagement from "./admissions/client";
import CreateClient from "./admissions/client/create";
import EditClient from "./admissions/client/edit";
import AdmissionsGroupUserManagement from "./admissions/group";
import PermissionGroupManagement from "./system/permission";
import ReportAdmissions from "./admissions/report";
import AttendanceManagement from "./student/attendance";
import NotificationManagement from "./noti";
import CreateNotiManagement from "./noti/create";
import EditNotiManagement from "./noti/edit";
import BusManagement from "./bus/info";
import CreateBusManagement from "./bus/info/create";
import EditBusManagement from "./bus/info/edit";
import BusRegisterManagement from "./bus/register";
import DetailBusRegisterManagement from "./bus/register/detail";
import DetailBusReportAttendanceManagement from "./bus/report";
import StandardFeesManagement from "./wallet/standard-fees";
import CreateFeesManagement from "./wallet/standard-fees/create";
import EditFeesManagement from "./wallet/standard-fees/edit";
import DetailFeesManagement from "./wallet/standard-fees/detail";
import InvoiceManagement from "./wallet/invoice";
import CreateInvoiceManagement from "./wallet/invoice/create";
import BusTypeManagement from "./bus/type";
import CreateBusRegisterManagement from "./bus/register/create";
import DetailBusReportManagement from "./bus/report/detail";
import DiscountManagement from "./wallet/discount";
import CreateDiscountManagement from "./wallet/discount/create";
import EditDiscountManagement from "./wallet/discount/edit";
import SchoolManagement from "./system/school-info";
import BusRegisterPaymentManagement from "./bus/payment";
import LogManagement from "./log";
import FoodTypeManagement from "./menu/food-category";
import SupplierManagement from "./menu/supplier";
import FoodManagement from "./menu/food";
import CreateFoodManagement from "./menu/food/create";
import EditFoodManagement from "./menu/food/edit";
import ClassCLBManagement from "./clb/class";
import DetailClassCLBManagement from "./clb/class/edit";
import CLBRegisterPaymentManagement from "./clb/payment";
import CreateClassCLBManagement from "./clb/class/create";
import ServiceManagement from "./service/info";
import MenuServiceManagement from "./menu/service";
import CreateServiceManagement from "./service/info/create";
import ServiceRegisterPaymentManagement from "./service/register";
import AttendanceCLBManagement from "./clb/attendance";
import ConfigLateManagement from "./late-pick-up/config";
import AttendanceLatePickUpManagement from "./late-pick-up/attendance";
import PickLateUpPaymentManagement from "./late-pick-up/payment";
import MenuManagement from "./menu/menu";
import CreateMenuManagement from "./menu/menu/create";
import EditMenuManagement from "./menu/menu/edit";
import CreateMenuWeekManagement from "./menu/menu-week";
import RegisterEatManagement from "./menu/register";
import EatPaymentManagement from "./menu/payment";
import ParentsManagement from "./parents";
import DiscountSpecialManagement from "./wallet/discount-special";
import FeeManagement from "./wallet/fee";
import CreateFeeManagement from "./wallet/fee/create";
import RegisterCLBManagement from "./clb/register";
import DetailRegisterCLBManagement from "./clb/register/detail";
import CreateServiceItemManagement from "./service/product/create";
import ServiceItemManagement from "./service/product";
import EditServiceItemManagement from "./service/product/edit";
import EditServiceManagement from "./service/info/edit";
import RegisterServiceManagement from "./service/register";
import DetailRegisterServiceManagement from "./service/register/detail";
import DiscountAdmissionsZoneManagement from "./wallet/discount-admissions-zone";
import DiscountAdmissionsRegisterManagement from "./wallet/discount-admissions-register";
import FeeItemManagement from "./wallet/fee-item";
import EditFeeManagement from "./wallet/fee/edit";
import FeeStudentManagement from "./wallet/fee-student";
import ViewDetailFeeStudentManagement from "./wallet/fee/detail-fee-student";
import FoodGroupManagement from "./menu/food-group";
import NewsManagement from "./news";
import CreateNewsManagement from "./news/create";
import EditNewsManagement from "./news/edit";
import DetailFeeStudentManagement from "./wallet/fee-student/detail";
import DetailInvoiceManagement from "./wallet/invoice/detail";
import FoodEatManagement from "./menu/food-eat";

class Admin extends React.Component {
        constructor(props) {
                super(props);
                this.state = {
                        isAdmin: false
                }
        }

        componentWillMount() {
                let userType = localStorage.getItem("sas_school_userType")
                this.setState({isAadmin: userType === "ADMIN"})
        }

        render() {
                return (
                    <Routes>
                            <Route path="/" element={<Profile/>} />
                            <Route path="/quan-ly-thong-tin-ca-nhan" element={<Profile/>}/>
                            {checkPermission("SCHOOL_EDIT") && <Route path="/sua-truong-hoc" element={<EditSchool/>} />}
                            <Route path="/them-truong-hoc" element={<CreateSchool/>} />
                            <Route path="/chi-tiet-truong-hoc" element={<DetailSchool/>} />
                            <Route path="/danh-sach-truong-hoc" element={<SchoolManagement/>} />
                            <Route path="/sua-truong-hoc" element={<EditSchool/>} />
                            <Route path="/khai-bao-du-lieu" element={<DataDeclarationManagement/>} />
                            <Route path="/ket-chuyen-du-lieu" element={<DataTransferManagement/>} />

                            <Route path="/quan-ly-nhom-nguoi-dung" element={<GroupUserManagement/>} />
                            {checkPermission("GROUP_USER_DETAIL") && <Route path="/phan-quyen-nhom-nguoi-dung" element={<PermissionGroupManagement/>} />}
                            <Route path="/quan-ly-nguoi-dung" element={<UserManagement/>} />
                            <Route path="/chi-tiet-nguoi-dung" element={<DetailUser/>} />
                            <Route path="/quan-ly-thong-tin-hoc-sinh" element={<StudentInfoManagement/>} />

                            <Route path="/them-moi-ho-so-hoc-sinh" element={<CreateStudentManagement/>} />
                            <Route path="/sua-ho-so-hoc-sinh" element={<EditStudentManagement/>} />
                            <Route path="/chi-tiet-ho-so-hoc-sinh" element={<DetailStudentManagement/>} />
                            <Route path="/diem-danh" element={<AttendanceManagement/>} />

                            <Route path="/phan-lop-hoc-sinh-dau-cap" element={<AcceptingTransferStudentManagement/>} />

                            <Route path="/danh-sach-can-bo" element={<StaffManagement/>} />
                            <Route path="/them-moi-can-bo" element={<CreateStaff/>} />
                            <Route path="/sua-can-bo" element={<EditStaff/>} />
                            <Route path="/chi-tiet-can-bo" element={<DetailStaff/>} />

                            <Route path="/quan-ly-can-bo/phan-cong-chu-nhiem" element={<AcceptingTransferStudentManagement/>} />
                            <Route path="/quan-ly-can-bo/lam-thay-chu-nhiem" element={<AcceptingTransferStudentManagement/>} />

                            <Route path="/admissions/chien-dich-tuyen-sinh" element={<AdmissionsManagement/>} />
                            <Route path="/admissions/quan-ly-nhom-khach-hang" element={<AdmissionsGroupUserManagement/>} />

                            <Route path="/admissions/danh-sach-khach-hang" element={<ClientsManagement/>} />
                            <Route path="/admissions/danh-sach-khach-hang/them-moi" element={<CreateClient/>} />
                            <Route path="/admissions/danh-sach-khach-hang/sua" element={<EditClient/>} />

                            <Route path="/admissions/bao-cao" element={<ReportAdmissions/>} />
                            <Route path="/quan-ly-phan-quyen" element={<PermissionGroupManagement/>} />

                            <Route path="/quan-ly-thong-bao" element={<NotificationManagement/>} />
                            <Route path="/them-moi-thong-bao" element={<CreateNotiManagement/>} />
                            <Route path="/sua-thong-bao" element={<EditNotiManagement/>} />

                            <Route path="/quan-ly-tin-tuc" element={<NewsManagement/>} />
                            <Route path="/them-moi-tin-tuc" element={<CreateNewsManagement/>} />
                            <Route path="/sua-tin-tuc" element={<EditNewsManagement/>} />

                            <Route path="/danh-sach-tuyen-xe-bus" element={<BusManagement/>} />
                            <Route path="/them-moi-tuyen-xe" element={<CreateBusManagement/>} />
                            <Route path="/sua-tuyen-xe-bus" element={<EditBusManagement/>} />

                            <Route path="/danh-sach-dang-ky-xe-bus" element={<BusRegisterManagement/>} />
                            <Route path="/chi-tiet-dang-ky-xe-bus" element={<DetailBusRegisterManagement/>} />
                            <Route path="/dang-ky-xe-bus" element={<CreateBusRegisterManagement/>} />
                            <Route path="/danh-sach-thanh-toan" element={<BusRegisterPaymentManagement/>} />

                            <Route path="/diem-danh-xe-bus" element={<DetailBusReportAttendanceManagement/>} />
                            <Route path="/chi-tiet-diem-danh-xe-bus" element={<DetailBusReportManagement/>} />

                            <Route path="/quan-ly-loai-tuyen-xe-bus" element={<BusTypeManagement/>} />
                            <Route path="/cac-khoan-phi-tieu-chuan" element={<StandardFeesManagement/>} />
                            <Route path="/tao-moi-khoan-phi" element={<CreateFeesManagement/>} />
                            <Route path="/chi-tiet-moi-khoan-phi" element={<DetailFeesManagement/>} />
                            <Route path="/sua-khoan-phi" element={<EditFeesManagement/>} />
                            <Route path="/xem-chi-tiet-cach-tinh-hoc-phi" element={<ViewDetailFeeStudentManagement/>} />

                            <Route path="/quan-ly-uu-dai" element={<DiscountManagement/>} />
                            <Route path="/tao-moi-uu-dai" element={<CreateDiscountManagement/>} />
                            <Route path="/sua-uu-dai" element={<EditDiscountManagement/>} />

                            <Route path="/cau-hinh-uu-dai-tuyen-sinh-khu-vuc" element={<DiscountAdmissionsZoneManagement/>} />
                            <Route path="/cau-hinh-uu-dai-tuyen-sinh-ngay-dang-ky" element={<DiscountAdmissionsRegisterManagement/>} />
                            <Route path="/cau-hinh-uu-dai-dac-biet" element={<DiscountSpecialManagement/>} />

                            <Route path="/cau-hinh-cac-khoan-phi" element={<FeeItemManagement/>} />
                            <Route path="/cau-hinh-gia-hoc-phi" element={<FeeManagement/>} />
                            <Route path="/them-moi-gia-hoc-phi" element={<CreateFeeManagement/>} />
                            <Route path="/sua-gia-hoc-phi" element={<EditFeeManagement/>} />
                            <Route path="/quan-ly-hoc-phi-hoc-sinh" element={<FeeStudentManagement/>} />
                            <Route path="/chi-tiet-hoc-phi-hoc-sinh" element={<DetailFeeStudentManagement/>} />

                            <Route path="/quan-ly-cac-khoan-thu" element={<InvoiceManagement/>} />
                            <Route path="/them-khoan-thu-chi" element={<CreateInvoiceManagement/>} />
                            <Route path="/chi-tiet-cac-khoan-thu-chi" element={<DetailInvoiceManagement/>} />
                            <Route path="/log-management" element={<LogManagement/>} />

                            <Route path="/loai-thuc-pham" element={<FoodTypeManagement/>} />
                            <Route path="/nhom-thuc-pham" element={<FoodGroupManagement/>} />
                            <Route path="/quan-ly-mon-an" element={<FoodEatManagement/>} />

                            <Route path="/quan-ly-thuc-pham" element={<FoodManagement/>} />
                            <Route path="/tao-thuc-pham" element={<CreateFoodManagement/>} />
                            <Route path="/sua-thuc-pham" element={<EditFoodManagement/>} />
                            <Route path="/nha-cung-cap" element={<SupplierManagement/>} />
                            <Route path="/dich-vu-khac" element={<MenuServiceManagement/>} />

                            <Route path="/quan-ly-thuc-don" element={<MenuManagement/>} />
                            <Route path="/tao-thuc-don" element={<CreateMenuManagement/>} />
                            <Route path="/sua-thuc-don" element={<EditMenuManagement/>} />

                            <Route path="/thuc-don-tuan" element={<CreateMenuWeekManagement/>} />
                            <Route path="/dang-ky-an" element={<RegisterEatManagement/>} />
                            <Route path="/thanh-toan-an" element={<EatPaymentManagement/>} />

                            <Route path="/diem-danh-clb" element={<AttendanceCLBManagement/>} />

                            <Route path="/quan-ly-lop-clb" element={<ClassCLBManagement/>} />
                            <Route path="/them-moi-lop-clb" element={<CreateClassCLBManagement/>} />
                            <Route path="/chi-tiet-lop-clb" element={<DetailClassCLBManagement/>} />

                            <Route path="/quan-ly-dang-ky-clb" element={<RegisterCLBManagement/>} />
                            <Route path="/them-hoc-sinh-vao-lop-clb" element={<DetailRegisterCLBManagement/>} />

                            <Route path="/quan-ly-thanh-toan-clb" element={<CLBRegisterPaymentManagement/>} />

                            <Route path="/quan-ly-san-pham-dich-vu" element={<ServiceItemManagement/>} />
                            <Route path="/them-moi-san-pham-dich-vu" element={<CreateServiceItemManagement/>} />
                            <Route path="/sua-san-pham-dich-vu" element={<EditServiceItemManagement/>} />

                            <Route path="/quan-ly-dich-vu-khac" element={<ServiceManagement/>} />
                            <Route path="/them-moi-dich-vu-khac" element={<CreateServiceManagement/>} />
                            <Route path="/sua-dich-vu-khac" element={<EditServiceManagement/>} />

                            <Route path="/quan-ly-dang-ky-dich-vu" element={<RegisterServiceManagement/>} />
                            <Route path="/chi-tiet-dang-ky-dich-vu" element={<DetailRegisterServiceManagement/>} />


                            <Route path="/quan-ly-thanh-toan-dich-vu-khac" element={<ServiceRegisterPaymentManagement/>} />

                            <Route path="/cau-hinh-gia-don-muon" element={<ConfigLateManagement/>} />
                            <Route path="/quan-ly-don-muon" element={<AttendanceLatePickUpManagement/>} />
                            <Route path="/quan-ly-thanh-toan-don-muon" element={<PickLateUpPaymentManagement/>} />

                            <Route path="/quan-ly-phu-huynh" element={<ParentsManagement/>} />
                    </Routes>
                )
        }
}

export default Admin
